import { render, staticRenderFns } from "./ed-stepper.vue?vue&type=template&id=312e5fe4&scoped=true&"
import script from "./ed-stepper.ts?vue&type=script&lang=ts&"
export * from "./ed-stepper.ts?vue&type=script&lang=ts&"
import style0 from "./ed-stepper.scss?vue&type=style&index=0&id=312e5fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e5fe4",
  null
  
)

export default component.exports